module["exports"] = {
  wide: ["Կիրակի", "Երկուշաբթի", "Երեքշաբթի", "Չորեքշաբթի", "Հինգշաբթի", "Ուրբաթ", "Շաբաթ"],
  abbr: ["կրկ", "երկ", "երք", "չրք", "հնգ", "ուրբ", "շբթ"]
};